import type { IconeBarcoCondicao } from "./icone-barco.constants";

export interface CondicaoResolvida {
  /** Texto exibido: o rótulo do mapa ou, se desconhecido, o texto recebido. */
  readonly label: string;
  /** Obra em seco (só para valores conhecidos). */
  readonly seco: boolean;
  /** Valor presente no mapa de `CONDICOES_BARCO`. */
  readonly known: boolean;
}

/**
 * Mapa da condição da parada (texto livre do core). Chave = texto sem acento, sem espaços nas pontas e em minúsculas;
 * valor desconhecido não entra aqui e a tela mostra só o texto recebido.
 */
export const CONDICOES_BARCO: Readonly<Record<string, { label: string; seco: boolean }>> = {
  seco: { label: "Seco", seco: true },
  "em seco": { label: "Seco", seco: true },
  molhado: { label: "Molhado", seco: false },
};

function chaveDaCondicao(condicao: string): string {
  return condicao
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();
}

/** Condição do core (texto livre) para rótulo e destaque; `null` ou vazio = sem condição. */
export function resolverCondicao(condicao: string | null | undefined): CondicaoResolvida | null {
  const texto = condicao?.trim() ?? "";
  if (!texto) return null;

  const definicao = CONDICOES_BARCO[chaveDaCondicao(texto)];
  return definicao
    ? { label: definicao.label, seco: definicao.seco, known: true }
    : { label: texto, seco: false, known: false };
}

/** Condição para o desenho do `IconeBarco`; sem condição ou valor desconhecido = `null` (o card usa o molhado, sem tooltip). */
export function condicaoDoBarco(condicao: string | null | undefined): IconeBarcoCondicao | null {
  const resolvida = resolverCondicao(condicao);
  if (!resolvida?.known) return null;
  return resolvida.seco ? "seco" : "molhado";
}
